import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import i18next from 'i18next';
import { combineEpics } from 'web-app/util/redux-observable';
import DayCareApi from 'signin-app/api/daycare-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { defaultErrorDuration } from 'web-app/react/global-event/helpers/constants';
import childCheckIn from './check-in/epics';
import childCheckOut from './check-out/epics';
import * as Actions from './actions';
const fetchChild = action$ => action$.pipe(ofType(Actions.fetchChild.type), mergeMap(({ payload }) => DayCareApi.child(payload.accessToken, payload.childId).pipe(map(response => {
    return Actions.fetchChildSuccess.action(response);
}), catchError(e => {
    dispatchStatusMessageEvent({
        message: i18next.t($ => $.somethingWentWrong),
        statusType: 'Error',
        sticky: false,
        e2eId: '',
        duration: defaultErrorDuration,
    });
    return of(Actions.fetchChildFailed.action(e));
}))));
export default combineEpics(fetchChild, childCheckIn, childCheckOut);
